import React from 'react';
import UserReport from '../../components/Report/User';

const UserReportPage = () => {
	return <UserReport />;
};

export default UserReportPage;
